<app-loading-screen *ngIf="spinnergetcomment">Loading Comment</app-loading-screen>
<app-loading-screen *ngIf="spinnersavecomment">Saving Comment</app-loading-screen>
<div *ngIf="commentsloaded | async" class="comments-container">
  <div class="comments-header">
    <h1 class="comments-title">Comments: {{ currentYear }}</h1>
    <div *ngIf="compno!==null" class="company-info">
      {{ prfNumber.toUpperCase() }} - {{ prfName }}
    </div>
  </div>

  <div class="comments-content">
    <div class="instruction-text" *ngIf="!isReadOnly">
      Please add, edit or review your comment for this year's Premium Report.
    </div>
    <div class="sub-instruction-text" *ngIf="!isReadOnly">
      Any information explaining substantial differences in your report over the year will help expedite the approval
      process.
    </div>

    <form class="comments-form">
      <div class="textarea-container">
        <textarea 
          [readonly]="isReadOnly" 
          [(ngModel)]="comment" 
          name="comment" 
          placeholder="Enter your comments here..."
          class="comments-textarea"
          (input)="updateCharacterCount()">
        </textarea>
        <div class="character-count">{{ characterCount || 0 }} characters</div>
      </div>
      
      <div *ngIf="!isReadOnly" class="button-container">
        <button 
          type="button" 
          class="confirm-button" 
          (click)="onsubmit()">
          Confirm Information
        </button>
      </div>
    </form>
  </div>
</div>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>